module.exports = __webpack_public_path__ + "static/img/PW.761273ab.svg";